import { render, staticRenderFns } from "./PivotGrid.vue?vue&type=template&id=56dab49b&scoped=true&"
import script from "./PivotGrid.vue?vue&type=script&lang=ts&"
export * from "./PivotGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dab49b",
  null
  
)

export default component.exports